import React, { useEffect } from "react";

import { RoutePaths } from "@main/router/config/routePaths";
import { useMatch } from "react-router-dom";

const useScreenDimensions = () => {
  const [isMobileView, setIsMobileView] = React.useState<boolean>(window.innerWidth < 768);

  useEffect(() => {
    const onResize = (e: UIEvent) => {
      if (e.target instanceof Window) {
        setIsMobileView(e.target.innerWidth < 768);
      }
    };

    window.addEventListener("resize", onResize, true);

    return () => {
      window.removeEventListener("resize", onResize, true);
    };
  }, []);

  const isTicketDetailsPage = Boolean(useMatch(RoutePaths.USER_FEEDBACK_DETAILS));
  const isCrashEventDetailsPage = Boolean(useMatch(RoutePaths.CRASH_REPORT_EVENT));
  const isAppUserDetailsPage = Boolean(useMatch(RoutePaths.USER_DETAILS));

  const shouldHideLayoutViews: boolean =
    (isTicketDetailsPage || isCrashEventDetailsPage || isAppUserDetailsPage) && isMobileView;

  return { isMobileView, shouldHideLayoutViews };
};

export { useScreenDimensions };
